// src/components/list/AddFirstPanel.tsx

import { Alert, Button, Typography } from '@mui/material'

import { HStack } from '../HStack'

type Props = {
  onClick: () => void
}

export const AddFirstPanel = ({ onClick }: Props) => (
  <HStack justifyContent={'center'}>
    <Alert severity={'info'} sx={{ width: 0.5 }}>
      <Typography sx={{ fontWeight: 'bold' }}>
        Erstellen Sie Ihre erste Kachel
      </Typography>

      <Button onClick={onClick} sx={{ mt: 2 }}>
        Neue Kachel
      </Button>
    </Alert>
  </HStack>
)
